import type {
  BoltOnDischargesQueryVariables,
  Bolt_On_Discharges_Bool_Exp
} from "gql/api";
import { Order_By } from "gql/api";

export function deleteBoltOnDischarges(
  arr: Array<string>
): Bolt_On_Discharges_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function restoreBoltOnDischarges(
  arr: Array<string>
): Bolt_On_Discharges_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

const order_by = [
  { manufacturer: Order_By.Asc },
  { series_model: Order_By.Asc },
  { tubing_diameter_inches: Order_By.Asc }
];

export const defaultBoltOnDischargesVars: BoltOnDischargesQueryVariables = {
  order_by,
  where: {
    is_hps: { _eq: false }
  }
};

export const adminBoltOnDischargesVars: BoltOnDischargesQueryVariables = {
  order_by,
  where: {
    is_hps: { _eq: false }
  }
};

export const kocBoltOnDischargesVars: BoltOnDischargesQueryVariables = {
  order_by,
  where: {
    _and: [
      {
        _or: [
          { include_koc_timestamp: { _is_null: false } },
          { only_koc_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: false } }
    ]
  }
};

export const ecopetrolBoltOnDischargesVars: BoltOnDischargesQueryVariables = {
  order_by,
  where: {
    _and: [
      {
        _or: [
          { include_ecopetrol_timestamp: { _is_null: false } },
          { only_ecopetrol_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: false } }
    ]
  }
};
